/* Magiczna Bransoletka: zestaw 1/2/3 sztuki, wzor i kolor wybierane osobno dla kazdej sztuki.
   Po dodaniu do koszyka zostajemy na stronie: okienko z potwierdzeniem i licznik w pasku u gory. */
(function(){
  if(window.__mbInit) return; window.__mbInit = true;
  document.body.classList.add('otl-landing');
  var sec = document.querySelector('[data-mb-hero]'); if(!sec) return;
  var data = JSON.parse(sec.querySelector('script[data-mb-data]').textContent);
  var pack = Number(sec.getAttribute('data-mb-pack')) || 1;
  var slots = Array.prototype.slice.call(sec.querySelectorAll('[data-mb-slot]'));
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  function money(c){ return (c/100).toFixed(2).replace('.', ',') + ' zł'; }
  function find(o1, o2){ for(var i = 0; i < data.variants.length; i++){ var v = data.variants[i]; if(v.o1 === o1 && v.o2 === o2) return v; } return null; }
  function pressed(el, sel){ return el.querySelector(sel + '[aria-pressed=true]'); }
  function setMain(src, srcset, alt){
    var m = sec.querySelector('[data-mb-main]'); if(!m || !src) return;
    m.src = src; if(srcset) m.srcset = srcset; if(alt) m.alt = alt;
  }
  function refresh(slot){
    var o1 = pressed(slot, '[data-mb-pattern]').getAttribute('data-mb-pattern');
    var cur = pressed(slot, '[data-mb-color]');
    var colors = slot.querySelectorAll('[data-mb-color]');
    var pick = null;
    colors.forEach(function(b){ var ok = !!find(o1, b.getAttribute('data-mb-color')); b.disabled = !ok; if(ok && !pick) pick = b; });
    if(!cur || cur.disabled) cur = pick;
    colors.forEach(function(b){ b.setAttribute('aria-pressed', b === cur ? 'true' : 'false'); });
    var o2 = cur ? cur.getAttribute('data-mb-color') : '';
    slot.__v = find(o1, o2);
    var label = slot.querySelector('[data-mb-slot-label]'); if(label) label.textContent = o1 + ', ' + o2.toLowerCase();
    return slot.__v;
  }
  function totals(){
    var t = data.packs[pack] || data.packs[1];
    sec.querySelectorAll('[data-mb-total]').forEach(function(el){ el.textContent = money(t); });
    var note = sec.querySelector('[data-mb-note]');
    if(note) note.textContent = t >= data.free ? 'darmowa dostawa' : '+ dostawa 9,99 zł, od 2 sztuk za darmo';
    slots.forEach(function(s, i){ s.hidden = i >= pack; });
  }
  function updateCount(n){
    document.querySelectorAll('.mb-top a[href$="/cart"]').forEach(function(a){
      var b = a.querySelector('.mb-top__count');
      if(n > 0){ if(!b){ b = document.createElement('span'); b.className = 'mb-top__count'; a.appendChild(b); } b.textContent = n; }
      else if(b){ b.remove(); }
      a.setAttribute('aria-label', 'Koszyk, produktów: ' + n);
    });
  }
  var toast;
  function showToast(added, count){
    if(!toast){
      toast = document.createElement('div');
      toast.className = 'mb-toast'; toast.setAttribute('role', 'status');
      toast.innerHTML = '<p class="mb-toast__title">✓ Dodano do koszyka</p><p class="mb-toast__text"></p>' +
        '<div class="mb-toast__btns"><a class="mb-toast__go" href="' + root + 'cart">Przejdź do koszyka</a>' +
        '<button type="button" class="mb-toast__close">Kontynuuj zakupy</button></div>';
      document.body.appendChild(toast);
      toast.querySelector('.mb-toast__close').addEventListener('click', function(){ toast.classList.remove('is-visible'); });
    }
    toast.querySelector('.mb-toast__text').textContent = (added === 1 ? '1 bransoletka' : added + ' bransoletki') + ' · w koszyku: ' + count;
    toast.classList.add('is-visible');
    clearTimeout(toast.__t); toast.__t = setTimeout(function(){ toast.classList.remove('is-visible'); }, 7000);
  }
  slots.forEach(refresh); totals();
  sec.addEventListener('click', function(e){
    var pat = e.target.closest('[data-mb-pattern]'), col = e.target.closest('[data-mb-color]');
    if(pat || col){
      var btn = pat || col, slot = btn.closest('[data-mb-slot]'); if(!slot || btn.disabled) return;
      var sel = pat ? '[data-mb-pattern]' : '[data-mb-color]';
      slot.querySelectorAll(sel).forEach(function(b){ b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var v = refresh(slot); if(v) setMain(v.img, v.srcset, v.o1 + ', ' + v.o2);
      return;
    }
    var th = e.target.closest('[data-mb-thumb]');
    if(th){
      sec.querySelectorAll('[data-mb-thumb]').forEach(function(b){ b.setAttribute('aria-current', b === th ? 'true' : 'false'); });
      setMain(th.getAttribute('data-img'), th.getAttribute('data-srcset'), th.getAttribute('data-alt'));
      return;
    }
    var atc = e.target.closest('[data-mb-atc]');
    if(atc){
      e.preventDefault();
      var msg = sec.querySelector('[data-mb-msg]'), counts = {}, order = [];
      slots.slice(0, pack).forEach(function(s){ var v = s.__v; if(!v) return; if(!counts[v.id]){ counts[v.id] = 0; order.push(v.id); } counts[v.id]++; });
      var items = order.map(function(id){ return { id: id, quantity: counts[id] }; });
      var btns = sec.querySelectorAll('[data-mb-atc]');
      btns.forEach(function(b){ b.disabled = true; });
      if(msg) msg.textContent = '';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if(!r.ok) throw new Error('add'); return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          updateCount(cart.item_count);
          showToast(pack, cart.item_count);
          btns.forEach(function(b){ b.disabled = false; });
        })
        .catch(function(){ if(msg) msg.textContent = 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.'; btns.forEach(function(b){ b.disabled = false; }); });
    }
  });
  sec.addEventListener('change', function(e){
    var r = e.target.closest('[data-mb-pack-input]'); if(!r) return;
    pack = Number(r.value); totals();
  });
  var bar = sec.querySelector('[data-mb-sticky]'), target = sec.querySelector('.otl-hero__grid [data-mb-atc]');
  if(bar && target && 'IntersectionObserver' in window){
    new IntersectionObserver(function(en){ en.forEach(function(x){ bar.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); }); }).observe(target);
  }
})();